import { Component, OnInit, ViewChild } from '@angular/core';
import { BtnCellRenderer } from 'src/app/core/grid/btn-cell-render.component';
import { MatDialog } from '@angular/material/dialog';
import { SubTaskIconRenderer } from 'src/app/core/grid/subtask-icon-render.component';
import { Router } from '@angular/router';
import { AddTaskDialogComponent } from 'src/app/core/dialogs/add-task-dialog/add-task-dialog.component';
import { DeleteCategoryDialogComponent } from 'src/app/core/dialogs/delete-category-dialog/delete-category-dialog.component';
import { TaskService } from 'src/app/service/task.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { BoardsService } from 'src/app/service/boards.service';
import { FilterChangedEvent, GridOptions } from 'ag-grid-community';
export interface deleteTaskData {
  id: Number;
  task_name: string;
  page;
}
export interface DialogData {
  performAction: string;
  task_id
  page;
  placeholderOP;
  placeholdercate;
  placeholderdesc;
}
@Component({
  selector: 'app-task',
  templateUrl: './task.component.html',
  styleUrls: ['./task.component.scss'],
  standalone: false,  // NOSONAR
})
export class TaskComponent implements OnInit {
  gridApi: any;
  gridColumnApi: any
  gridOptions: GridOptions;
  setPagination = 'true';
  defaultColDef;
  paginationPageSize: number = 30;
  columnDefs;
  rowData;
  icons;
  context: any;
  successMessage = '';
  errorMessage = '';
  frameworkComponents: { btnCellRenderer: typeof BtnCellRenderer; };
  @ViewChild('agGrid', { static: true }) agGrid;
  currentPageNo: any;
  currentPageBoolean: boolean = false;
  totalPage: any;
  currentPageForTotalPage: any;
  isLastPageFound: any;
  rowCount;
  selectedRows: any = [];
  dynamicHeight: number;
  totalRecords = 0; // Replace with your actual total records count
  sRecord = 1;
  eRecord = 1;
  cPage = 1;
  tPage = 0;
  rpPage: any = 30;
  endRecord = 0;
  pgDropDown = [
    { value: 5, selected: false },
    { value: 10, selected: false },
    { value: 20, selected: false },
    { value: 30, selected: true },
    { value: 50, selected: false },
  ]
  constructor(public dialog: MatDialog, private readonly router: Router,
    private readonly taskService: TaskService, private readonly ngxUiLoaderService: NgxUiLoaderService,
    private readonly boardService: BoardsService) {
    this.dynamicHeight = 0.665 * (window.innerHeight);
    this.context = {
      componentParent: this
    };
    this.gridOptions = { suppressRowClickSelection: true }
    this.columnDefs = [
      {
        headerName: "CATEGORY", headerClass: "category", field: "categoriesDTO.description", width: 300, cellClass: "cell_category",
        sortable: true, unSortIcon: true,
        suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        autoHeight: true
      },
      {
        headerName: "DESCRIPTION", headerClass: "description", field: "description", width: 710, cellClass: "cell_desc",
        sortable: true, unSortIcon: true,
        suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        autoHeight: true
      },
      {
        headerName: "SUB TASK", headerClass: "subtask", field: "subtask", cellClass: "cell_subtask",
        width: 120,
        // suppressSizeToFit: true
        cellRenderer: SubTaskIconRenderer,
        cellRendererParams: {
          clicked: function (_field: any, _act: any) {
            // do something
          }
        },
      },
      {
        headerName: "ACTIONS", field: "task_action", cellClass: "cell_action",
        width: 120,
        cellRenderer: BtnCellRenderer,
        cellRendererParams: {
          clicked: function (_field: any, _act: any) {
            // do something
          }
        },
      }];
    this.frameworkComponents = {
      btnCellRenderer: BtnCellRenderer
    };
    this.icons = {
      sortUnSort: '<i class="fa fa-sort" style="font-weight:bold;color:black;"/>',
    };
    this.defaultColDef = {
      minWidth: 100,
      // filter: true,
      floatingFilter: true,
      wrapText: true
    };
  }
  goToNextPage() { this.gridApi.paginationGoToNextPage(); this.updatePaginationDetails(); }
  goToPreviousPage() { this.gridApi.paginationGoToPreviousPage(); this.updatePaginationDetails(); }
  goToFirstPage() { this.gridApi.paginationGoToFirstPage(); this.updatePaginationDetails(); }
  goToLastPage() { this.gridApi.paginationGoToLastPage(); this.updatePaginationDetails(); }
  onPageSizeChanged(event: any) { this.gridApi.paginationSetPageSize(Number(event.target.value)); this.updatePaginationDetails(); }
  getCurrentPage(): boolean {
    this.currentPageNo = this.agGrid.api?.paginationGetCurrentPage();
    if (this.currentPageNo == 0) { // NOSONAR
      this.currentPageBoolean = true;
    }
    else { this.currentPageBoolean = false; }
    return this.currentPageBoolean;
  }
  isLastPage(): boolean {
    this.totalPage = Number(this.agGrid.api?.paginationGetTotalPages());
    this.currentPageForTotalPage = Number(this.agGrid.api?.paginationGetCurrentPage()) + 1;
    if (this.totalPage == this.currentPageForTotalPage) { // NOSONAR
      this.isLastPageFound = true;
    }
    else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }
  rppChanged(event: any) {
    this.cPage = 1;
    this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value));
    this.updatePaginationDetails();
  }
  updatePaginationDetails() {
    if (this.gridApi) {
      this.cPage = this.gridApi.paginationGetCurrentPage() + 1;
      this.tPage = this.gridApi.paginationGetTotalPages();
      this.sRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + 1
      this.eRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + this.gridApi.paginationGetPageSize()
      this.totalRecords = this.gridApi.paginationGetRowCount();
      this.eRecord = this.totalRecords < this.eRecord ? this.totalRecords : this.eRecord;
    }
  }
  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
  }
  sizeToFit() { this.gridApi.sizeColumnsToFit(); }
  loadData() {
    this.ngxUiLoaderService.start("loader-01");
    //API Integration
    this.rowData = [];
    this.taskService.getDetails().subscribe(result => {
      console.info("calling getdetails");
      if (result?.length > 0) {
        this.rowData = result;
        this.rowCount = this.rowData.length;
        if (this.rowData.length) {
					this.totalRecords = this.rowData.length;
					this.paginationPageSize = this.rpPage !== 'ALL' ? this.paginationPageSize : this.totalRecords;
					this.tPage = this.rpPage !== 'ALL' ? Math.ceil(this.totalRecords / this.rpPage) : 1;
					this.sRecord = 1
					this.eRecord = this.rpPage > this.totalRecords ? this.totalRecords : this.rpPage
					if (this.cPage > this.tPage) {
						this.cPage = 1;
					}
				}
        localStorage.setItem('task-data', JSON.stringify(result));
      }
      else {
        setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
        }, 6500);
      }
      this.ngxUiLoaderService.stop("loader-01");
    });
  }
  ngOnInit(): void {
    this.ngxUiLoaderService.start("loader-01");
    // clear contingency data
    sessionStorage.removeItem('contData');
    this.boardService.deleteContingenyList().subscribe(_result => {
      // contingency list deleted
    });
    this.loadData();
  }
  refreshData() {
    this.ngxUiLoaderService.start("loader-01");
    const catTemp = JSON.parse(localStorage.getItem('task-data'));
    if (catTemp != '') { // NOSONAR
      this.rowData = catTemp;
      this.rowCount = this.rowData.length;
    }
    else {
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 6500);
    }
    this.ngxUiLoaderService.stop("loader-01");
  }
  openDialog(): void {
    console.info("open dialog");
    const dialogRef = this.dialog.open(AddTaskDialogComponent, {
      disableClose: true,
      width: '503px',
      data: { performAction: 'AddCell', placeholder: '' }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result.event == 'AddCell') { // NOSONAR
        const dataArr =
        {
          "taskID": null,
          "description": result.data1,
          "categoriesDTO": {
            "categoryID": result.data2,
            "description": result.data3,
            "errorMessage": null,
            "successMessage": null
          },
          "opDTO": {
            "url": null,
            "opID": result.data5,
            "description": result.data4,
            "successMessage": null
          },
          "parentID": null,
          "successMessage": null,
          "errorMessage": null
        }
        console.info("the data array", dataArr);
        this.taskService.addtasks(dataArr).subscribe(result => {
          if (!result) {
            this.loadData();
            this.errorMessage = 'Task already exists!';
            setTimeout(() => {
              this.successMessage = '';
              this.errorMessage = '';
            }, 5000);
          }
          else if (result) {
            this.loadData();
            this.successMessage = 'Task added successfully!';
            setTimeout(() => {
              this.successMessage = '';
              this.errorMessage = '';
            }, 5000);
          }
        });
      }
    });
  }
  deleteTaskRow(val) {
    let task_name;
    let id;
    console.info("result", this.rowData);
    this.rowData.filter(x => x.taskID == val).forEach(e => { // NOSONAR
      this.selectedRows.push(e);
      id = e.taskID;
      task_name = e.description;
    });
    const dialogRef = this.dialog.open(DeleteCategoryDialogComponent, {
      disableClose: true,
      width: '510px',
      data: { id: id, task_name: task_name, page: "task" }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.info('The dialog was closed', result);
      console.info("data to be deleted:", result.data);
      const deletejson = {
        "taskID": result.data
      }
      this.deleteRecords(deletejson);
    });
  }
  deleteRecords(dataArr) {
    this.ngxUiLoaderService.start("loader-01");
    this.taskService.deletetasks(dataArr).subscribe(_result => {
      this.successMessage = 'Deleted Row(s) Successfully!';
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 6500);
      //fetch latest row data after deleting
      this.loadData();
    });
  }
  editTaskRow(val) {
    let id;
    let task_name;
    let categoryID;
    let OPID;
    this.rowData.filter(x => x.taskID == val).forEach(e => { // NOSONAR
      id = e.taskID;
      task_name = e.description;
      categoryID = e.categoriesDTO?.categoryID;
      OPID = e.opDTO?.opID;
    });
    const dialogRef = this.dialog.open(AddTaskDialogComponent, {
      disableClose: true,
      width: '503px',
      data: {
        performAction: 'EditCell', placeholderdesc: task_name, placeholdercate: categoryID,
        placeholderOP: OPID, task_id: id, page: 'Task'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.info('The dialog was closed', result);
      if (result.event == 'EditCell') { // NOSONAR
        //API Integration
        const dataArr =
        {
          "taskID": id,
          "description": result.data1,
          "categoriesDTO": {
            "categoryID": result.data2,
            "description": result.data3
            ,
            "errorMessage": null,
            "successMessage": null
          },
          "opDTO": {
            "url": null,
            "opID": result.data5,
            "description": result.data4,
            "successMessage": null
          },
          "parentID": null,
          "successMessage": null,
          "errorMessage": null
        }
        this.ngxUiLoaderService.start("loader-01");
        this.taskService.edittasks(dataArr).subscribe(_result => {
          this.successMessage = 'Task updated successfully!';
          setTimeout(() => {
            this.successMessage = '';
            this.errorMessage = '';
          }, 6500);
          //fetch latest row data after editing
          this.loadData();
          // }
        });
      }
    });
  }
  openSubTask(val, desc) {
    const tempData = {
      taskid: val,
      taskidtitle: desc
    }
    this.router.navigateByUrl('/subtask', { state: tempData });
  }
  onFilterChanged(params: FilterChangedEvent) {
    this.rowCount = params.api.getDisplayedRowCount();
  }
}